import { render } from "./Security.vue?vue&type=template&id=4c4dfaae"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"
script.render = render

export default script